module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tara Taylor Quinn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" Tara Taylor Quinn, is a "), _c('I', [_vm._v("USA Today")]), _vm._v("–bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn’s novels have received critical acclaim, including the 2008 National Reader’s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including "), _c('I', [_vm._v("CBS Sunday Morning")]), _vm._v(". For additional offers, news, and contests, visit the author at tarataylorquinn.com. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RHSuug/tc-custom/9781460326060.jpg?1724411686709",
      "alt": "This image is the cover for the book Wife by Design, Where Secrets Are Safe"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wife by Design, Where Secrets Are Safe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this heartfelt romance series debut, two people devoted to helping others must make room in their lives to pursue their own connection.")]), _c('br'), _c('br'), _vm._v("When life hands you lemons, you make lemonade. That’s what Lynn Duncan believes. A single mother and nurse practitioner, she works at The Lemonade Stand, a unique women’s shelter on the California coast supported by various businesses. These include a physiotherapy service, where landscape designer Grant Bishop takes his disabled brother."), _c('br'), _c('br'), _vm._v("When Grant and Lynn first meet, they’re intensely attracted to each other—but they don’t see a future together. They’re too committed to the people they need to protect. For Lynn that’s three-year-old Kara and the residents at The Lemonade Stand. And Grant will sacrifice "), _c('i', [_vm._v("anything")]), _vm._v(" for his brother. That might have to include a relationship with Lynn..\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0